import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {LeadButtonTerms} from "../LeadButtonTerms";
import {LeadRodoTerms} from "../LeadRodoTerms";

interface IProps {
    isSending: boolean;
    buttonText: string;
    sendDisabled?: boolean;
    vendorName?: string;
    offerPersonalDataProcessorName?: string;
    rodoLinks?: {
        offerPersonalDataProcessorUrl?: string | null;
        offerPrivacyPolicyUrl?: string | null;
        vendorPrivacyPolicyFile?: string | null;
        vendorPrivacyPolicyUrl?: string | null;
    };
}

export const LeadFormSubmitFooter = (props: IProps) => {
    const {isSending, buttonText, vendorName, offerPersonalDataProcessorName, rodoLinks, sendDisabled} = props;

    const rodoTermsUrl = rpAppLink.rodoTerms.base();
    const vendorRodoTermsUrl =
        rodoLinks?.vendorPrivacyPolicyFile || rodoLinks?.offerPersonalDataProcessorUrl || rodoLinks?.offerPrivacyPolicyUrl || rodoLinks?.vendorPrivacyPolicyUrl;
    const showOfferPersonalDataProcessor = !!offerPersonalDataProcessorName && !!rodoLinks?.offerPersonalDataProcessorUrl;
    const name = showOfferPersonalDataProcessor ? `${offerPersonalDataProcessorName} - Przedstawiciel Dewelopera` : vendorName;
    const vendorRodoUrl = showOfferPersonalDataProcessor ? rodoLinks?.offerPersonalDataProcessorUrl : vendorRodoTermsUrl;

    return (
        <>
            <Button
                type="submit"
                variant="filled_primary"
                fullWidth
                className={css({mb: 1})}
                disabled={isSending || sendDisabled}
                isLoading={isSending}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.SEND_LEAD_BUTTON}
            >
                {buttonText}
            </Button>

            <LeadButtonTerms as="p" buttonText={buttonText} color="initial" mb={1} />

            <LeadRodoTerms
                as="p"
                hiddenInfo={{
                    linkTexts: ["Więcej", "Mniej"],
                    infoElement: (
                        <Text as="span" variant="info_txt_3" color="initial">
                            <Link href={rodoTermsUrl} target="_blank" textClassName={linkStyle}>
                                dowiedz się więcej o przetwarzaniu Twoich danych
                            </Link>
                            {name && (
                                <>
                                    , {name}{" "}
                                    {vendorRodoUrl && (
                                        <Link href={vendorRodoUrl} target="_blank" textClassName={linkStyle}>
                                            dowiedz się więcej o przetwarzaniu Twoich danych
                                        </Link>
                                    )}
                                </>
                            )}
                        </Text>
                    )
                }}
                color="initial"
                linkClassName={css({fontWeight: "bold"})}
                className={css({mb: 0.5})}
            />
        </>
    );
};

const linkStyle = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
